import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { modules } from './toolbar.setup';

export default function TextEditor({ value, onChange }: any) {
  return <ReactQuill theme="snow" value={value} onChange={onChange} className="h-60" modules={modules}/>;
}